'use client';
import Nodata from "@/components/shared/no-data/Nodata";
import { useCartContext } from "@/providers/CartContext";
import Image from "next/image";
import {Link} from "@/i18n/routing";
import {useLocale, useTranslations} from 'next-intl';
import {spaceAndRoundNumber} from '@/libs/number.util';
import {ClientTypes, CURRENCY_DEFAULT, PRIVATE_ROUTE_NAME} from '@/libs/constants/common.constants';
import {useBaseMutation} from '@/libs/api/baseRequests';
import {UPDATE_CLIENT_CART_SELF_QUERY} from '@/graphql/account';
import {useState} from 'react';
import {useUserContext} from '@/providers/UserContext';
import {useRouter} from '@/i18n/routing';

export default function HeaderCart({currency}) {
  const t = useTranslations('cart');
  
  const router = useRouter();
  const locale = useLocale();
  const {user} = useUserContext();
  const [submitting, setSubmitting] = useState(false);
  const {mutate: mutateCart} = useBaseMutation(UPDATE_CLIENT_CART_SELF_QUERY, {});
  
  const { cartProducts, deleteProductFromCart, cartTotalPrice } = useCartContext();
  const totalProduct = cartProducts.length;
  
  
  const onDeleteProduct = async (productId) => {
    if (submitting) return;
    
    if (!user) {
      deleteProductFromCart(productId);
      return;
    }
    setSubmitting(true);
    const result = await mutateCart({
      variables: {
        action: 'DELETE',
        productId,
        quantity: 1
      }
    });
    if (result.data) {
      deleteProductFromCart(productId);
    }
    setSubmitting(false);
  }

  return (
    <div
      id="ltn__utilize-cart-menu"
      className="ltn__utilize ltn__utilize-cart-menu"
    >
      <div className="ltn__utilize-menu-inner ltn__scrollbar">
        <div className="ltn__utilize-menu-head">
          <span className="ltn__utilize-menu-title">{t('cart')}</span>
          <button className="ltn__utilize-close">×</button>
        </div>
        <div className="mini-cart-product-area ltn__scrollbar">
          {!totalProduct ? (
            <Nodata text={t('emptyCart')} />
          ) : (
              cartProducts.map(({ product, quantity }, idx) => {
                // const { netPrice } = countDiscount(price, disc);
                return (
                    <div key={idx} className="mini-cart-item clearfix">
                      <div className="mini-cart-img">
                        <Link href={`/products/${product.alt}`}>
                          <Image
                              key={product.coverImage}
                              src={product.coverImage}
                              alt={product.title}
                              placeholder="blur"
                              blurDataURL={product.coverImage}
                              width={1000}
                              height={1000}
                              style={{height: 'auto', aspectRatio: 1, objectFit: 'cover'}}
                          />
                        </Link>
                        <span
                            onClick={() => onDeleteProduct(product.id)}
                            className="mini-cart-item-delete"
                        >
                          <i className="icon-cancel"></i>
                        </span>
                      </div>
                      <div className="mini-cart-info">
                        <h6>
                          <Link href={`/products/${product.alt}`}>
                            {" "}
                            {product.title}
                          </Link>
                        </h6>
                        <span className="mini-cart-quantity">
                          {quantity} x
                          {' '}
                          {product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                          <span>{spaceAndRoundNumber(user?.clientType === ClientTypes.WHOLESALER && product.price.wholesalePrice != null ? product.price.wholesalePrice : product.price.priceComputed)}</span>
                          {!product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                          {' = '}
                          {product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                          <span>{spaceAndRoundNumber(quantity * (user?.clientType === ClientTypes.WHOLESALER && product.price.wholesalePrice != null ? product.price.wholesalePrice : product.price.priceComputed))}</span>
                          {!product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                        </span>
                      </div>
                    </div>
                );
              })
          )}
        </div>
        <div className="mini-cart-footer">
          <div className="mini-cart-sub-total">
            <h5>
              {t('subtotal')}:
              {' '}
              {
                totalProduct > 0 && !!currency ? (
                    <span>
                      {user?.clientType === ClientTypes.WHOLESALER ? (
                          <span className="wholesale-word">{t('wholesale') + ' '}</span>
                      ) : ''}
                      {currency.left ? (<span className="currency-sign-font">{currency.symbol}</span>) : ''}
                      <span>{spaceAndRoundNumber(cartTotalPrice)}</span>
                      {!currency.left ? (<span className="currency-sign-font">{currency.symbol}</span>) : ''}
                    </span>
                ) : (
                    <span>
                      {currency?.left ? (<span className="currency-sign-font">{currency?.symbol ?? CURRENCY_DEFAULT}</span>) : ''}
                      <span>{spaceAndRoundNumber(0)}</span>
                      {!currency?.left ? (<span className="currency-sign-font">{currency?.symbol ?? CURRENCY_DEFAULT}</span>) : ''}
                    </span>
                )
              }
            </h5>
          </div>
          <div className="btn-wrapper">
            <button
                disabled={submitting}
                className="theme-btn-1 btn btn-effect-1 ltn__utilize-close"
                onClick={() => router.push(user ? { pathname: PRIVATE_ROUTE_NAME, query: { tab: 'cart' } } : { pathname: '/cart' }, { locale })}
            >
              {t('viewCart')}
            </button>
            <button
                disabled={submitting}
                className="theme-btn-2 btn btn-effect-2 ltn__utilize-close"
                onClick={() => router.push(user ? { pathname: `${PRIVATE_ROUTE_NAME}/checkout` } : { pathname: '/checkout' }, { locale })}
            >
              {t('checkout')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
